import { render, staticRenderFns } from "./TransactionPage.vue?vue&type=template&id=1338085e&scoped=true&"
import script from "./TransactionPage.vue?vue&type=script&lang=js&"
export * from "./TransactionPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPage.vue?vue&type=style&index=0&id=1338085e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338085e",
  null
  
)

export default component.exports